angular.module("iconoglobe").directive('qrcode', [function() {
    return {
       restrict:'A',
       scope: {
          url: "=qrcode"
       },
       link: function(scope, element, attrs) {
          if (scope.url) {
             var qrCode = new QRCodeStyling({
                width: 150,
                height: 150,
                type: "svg",
                data: scope.url,
                    margin: 0, 
                image: "i-i/qrz.svg",
                    qrOptions:{"typeNumber":"0","mode":"Byte","errorCorrectionLevel":"Q"},
                    imageOptions:{"hideBackgroundDots":false,"imageSize":0.4,"margin":0},
                    dotsOptions:{"type":"extra-rounded","color":"#8f8f8f"},
                    backgroundOptions:{"color":"#ffffff"},
                    dotsOptionsHelper:{"colorType":{"single":true,gradient:false},
                    gradient:{"linear":true,radial:false,color1:"#6a1a4c",color2:"#6a1a4c",rotation:"0"}},
                    cornersSquareOptions:{"type":"dot",color:"#000000",gradient:null},
                    cornersSquareOptionsHelper:{"colorType":{"single":true,gradient:false},
                    gradient:{"linear":true,radial:false,color1:"#000000",color2:"#000000",rotation:"0"}},
                    cornersDotOptions:{"type":"dot",color:"#000000"},
                    cornersDotOptionsHelper:{"colorType":{"single":true,gradient:false},
                    gradient:{"linear":true,radial:false,color1:"#000000",color2:"#000000",rotation:"0"}},
                    backgroundOptionsHelper:{"colorType":{"single":true,gradient:false},gradient:{"linear":true,radial:false,color1:"#ffffff",color2:"#ffffff",rotation:"0"}}
             });
             qrCode.append(element[0]);
             element[0].addEventListener('click', function(){
                qrCode.download({ name: "qr", extension: "svg" });
             });
          }
       }
    };
}]);



